/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";

export class ETransportNotificationStatusMeta extends JSONable{

  totalSize = 0;
  eTransportNotificationUploadStatus: string[] = [];
  eTransportNotificationCheckStatus:string[] = [];

}
